<template>
  <div>
    <CChartLine :datasets="revenues" labels="months" />
  </div>
</template>

<script>
import { CChartLine } from "@coreui/vue-chartjs";

export default {
  name: "ChartRevenue",
  components: { CChartLine },
  props: {
    revenues: { default: null, type: Array },
  }
};
</script>
